/* Product-specific search for the original, server-rendered TankTheTank Q&A. */
(function (root) {
  'use strict';

  function normalizeText(value) {
    var text = String(value == null ? '' : value).toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/\s+/g, ' ').trim();
  }

  function filterEntries(entries, query) {
    var normalized = normalizeText(query);
    if (!normalized) return entries.slice();
    var terms = normalized.split(' ');
    return entries.filter(function (entry) {
      var text = normalizeText(entry.text);
      return terms.every(function (term) { return text.indexOf(term) !== -1; });
    });
  }

  function paginateEntries(entries, requestedPage, requestedSize) {
    var size = Number(requestedSize);
    if (!isFinite(size) || size < 1 || Math.floor(size) !== size) size = 5;
    var totalPages = Math.ceil(entries.length / size);
    var page = Number(requestedPage);
    if (!isFinite(page)) page = 1;
    page = Math.min(Math.max(1, Math.floor(page)), Math.max(1, totalPages));
    var offset = (page - 1) * size;
    var items = entries.slice(offset, offset + size);
    return {
      items: items, page: page, pageSize: size,
      total: entries.length, totalPages: totalPages,
      start: items.length ? offset + 1 : 0,
      end: items.length ? offset + items.length : 0
    };
  }

  var api = { normalizeText: normalizeText, filterEntries: filterEntries, paginateEntries: paginateEntries };
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  root.TankTheTankQaSearch = api;

  function initialize() {
    var container = root.document.getElementById('simpAskQuestion');
    if (!container || container.getAttribute('data-ttt-search-ready') === 'true') return;
    var controls = container.querySelector('.ttt-qa-search-controls');
    var input = container.querySelector('#tankthetank-qa-search');
    var clear = container.querySelector('#tankthetank-qa-search-clear');
    var status = container.querySelector('#tankthetank-qa-search-status');
    var navigation = container.querySelector('#tankthetank-qa-pagination');
    var list = container.querySelector('.accordionSimpQA > ul');
    if (!controls || !input || !clear || !status || !navigation || !list) return;

    // Read the complete li: legacy rich answers can contain nested paragraphs.
    var entries = Array.prototype.map.call(list.children, function (node) {
      return { node: node, text: node.textContent || '' };
    });
    var pageSize = Number(root.tankTheTankQaPerPage) || 5;
    var page = 1;
    var current;

    function button(label, targetPage, ariaLabel, disabled, selected) {
      var element = root.document.createElement('button');
      element.type = 'button';
      element.className = 'ttt-qa-page';
      element.textContent = label;
      element.setAttribute('data-qa-page', String(targetPage));
      element.setAttribute('aria-label', ariaLabel);
      element.disabled = !!disabled;
      if (selected) element.setAttribute('aria-current', 'page');
      navigation.appendChild(element);
    }

    function render() {
      var query = input.value;
      var filtered = filterEntries(entries, query);
      current = paginateEntries(filtered, page, pageSize);
      page = current.page;
      entries.forEach(function (entry) { entry.node.hidden = true; });
      current.items.forEach(function (entry) { entry.node.hidden = false; });
      clear.hidden = !query;
      if (!current.total) {
        status.textContent = normalizeText(query) ? 'No questions or answers match your search.' : 'No questions yet.';
      } else {
        var noun = current.total === 1 ? 'question' : 'questions';
        status.textContent = 'Showing ' + current.start + '\u2013' + current.end + ' of ' + current.total + ' ' + noun + (normalizeText(query) ? ' matching your search.' : '.');
      }
      while (navigation.firstChild) navigation.removeChild(navigation.firstChild);
      navigation.hidden = current.totalPages < 2;
      if (navigation.hidden) return;
      button('\u00ab', page - 1, 'Previous Q&A page', page === 1, false);
      var pages = [1, current.totalPages];
      for (var number = Math.max(1, page - 2); number <= Math.min(current.totalPages, page + 2); number++) {
        if (pages.indexOf(number) === -1) pages.push(number);
      }
      pages.sort(function (a, b) { return a - b; });
      var previous = 0;
      pages.forEach(function (number) {
        if (previous && number - previous > 1) {
          var gap = root.document.createElement('span');
          gap.textContent = '\u2026';
          gap.setAttribute('aria-hidden', 'true');
          navigation.appendChild(gap);
        }
        button(String(number), number, 'Q&A page ' + number, false, number === page);
        previous = number;
      });
      button('\u00bb', page + 1, 'Next Q&A page', page === current.totalPages, false);
    }

    input.addEventListener('input', function () { page = 1; render(); });
    // WebKit's native search clear control may emit a search event as well.
    input.addEventListener('search', function () { page = 1; render(); });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { input.value = ''; page = 1; render(); }
      if (event.key === 'Enter') event.preventDefault();
    });
    clear.addEventListener('click', function () {
      input.value = ''; page = 1; render(); input.focus();
    });
    navigation.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || target.tagName !== 'BUTTON' || target.disabled) return;
      var requestedPage = Number(target.getAttribute('data-qa-page'));
      if (requestedPage === page) return;
      page = requestedPage;
      render();
      // Focus the new current-page button after the pager is redrawn.
      var selected = navigation.querySelector('[aria-current="page"]');
      if (selected) selected.focus();
    });
    render();
    controls.hidden = false;
    container.setAttribute('data-ttt-search-ready', 'true');
  }

  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})(typeof window !== 'undefined' ? window : null);
